<div [formGroup]="form" *ngIf="form">
    <div class="row">
        <div *ngIf="form.value.identifier" class="form-group" [ngClass]="(form.value.identifier)?'col-lg-6':'col-lg'">
            <label>{{'administration.sectionsManagement.equipment.code' | translate}}</label>
            <apc-form-input [class]="'form-control autogenerated'" [disabled]="true" formControlName="code" [type]="'text'">
            </apc-form-input>
        </div>
        <div class="form-group" [ngClass]="(form.value.identifier)?'col-lg-6':'col-lg'">
            <label>{{'administration.sectionsManagement.equipment.plate' | translate}}</label>
            <apc-form-input [class]="'form-control'" formControlName="name" [type]="'text'">
            </apc-form-input>
        </div>
    </div>
    <div class="row mt-5">
        <div class="form-group col-lg">
            <label>{{'administration.sectionsManagement.equipment.model' | translate}}</label>
            <apc-form-input [class]="'form-control'" formControlName="model" [type]="'text'">
            </apc-form-input>
        </div>

        <div class="form-group col-lg">
            <label>{{'administration.sectionsManagement.equipment.brand' | translate}}</label>
            <apc-form-input [class]="'form-control'" formControlName="brand" [type]="'text'">
            </apc-form-input>
        </div>


    </div>
    <div class="row mt-5 mb-3">
        <div class="form-group col-lg">
            <label>{{'administration.sectionsManagement.equipment.rentalCompany' | translate}}</label>
            <apc-form-input [class]="'form-control'" formControlName="rentalCompany" [type]="'text'">
            </apc-form-input>
        </div>

        <div class="form-group col-lg">
            <label>{{'administration.sectionsManagement.equipment.dateExpiration' | translate}}</label>
            <apc-form-input [class]="'form-control'" formControlName="dateExpiration" [type]="'date'">
            </apc-form-input>
        </div>
    </div>
</div>